import { render, staticRenderFns } from "./CampaignPackageEdit.vue?vue&type=template&id=4cdff031&scoped=true"
import script from "./CampaignPackageEdit.vue?vue&type=script&lang=js"
export * from "./CampaignPackageEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdff031",
  null
  
)

export default component.exports